import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useLeadSource } from '../../hooks/CompanyConfiguration/useLeadSource'
import AddLeadSource from './AddLeadSource'

export default function EditLeadSource() {
  const { leadSource, getLeadSource } = useLeadSource()
  const params = useParams()
  useEffect(() => {
    getLeadSource({ leadSourceId: params.leadSourceId })
  }, [params.leadSourceId])

  return <> {leadSource ? <AddLeadSource leadSource={leadSource} /> : <Loader />} </>
}
